import $ from 'jquery';

export default class {
  constructor() {
    this.apiUrl = window._env.config.apiUrl;
    this.url = window._env.config.url;

    this.init();
  }

  init() {
    this.$likeButtons = $('.feedback-action-like');
    this.$dislikeButtons = $('.feedback-action-dislike');
    this.$likeFeedback = $('.like-feedback');
    this.postId = this.$likeButtons.data('post-id');
    this.userId = this.$likeButtons.data('user-id');

    const {$likeButtons, $dislikeButtons} = this;


    if ($likeButtons) {
      $likeButtons.on('click', () => this.toggleLike());
    }

    if ($dislikeButtons) {
      $dislikeButtons.on('click', () => this.toggleLike(false));
    }
  }

  toggleLike(isThumbsUp = true) {
    const {
      apiUrl,
      postId,
      userId,
    } = this;

    if (!postId || !userId) {
      var snackbarContainer = document.querySelector('#demo-snackbar-example');
      var handler = () => {
        window.location = '/quiz/food';
      };
      var data = {
        message: 'Ah, you\'ll need to create a free account to share a rating.',
        timeout: 5000,
        actionHandler: handler,
        actionText: 'Create Account',
      };
      snackbarContainer.MaterialSnackbar.showSnackbar(data);

  
      
      return;
    }

    const type = isThumbsUp ? 'like' : 'dislike';

    this.updateState(isThumbsUp)

    $.ajax({
      type: 'POST',
      url: `${apiUrl}${type}/${postId}`,
      data: {
        post_id: postId,
        user_id: userId,
      },
    })
      .then(result => this.updatePercentage(JSON.parse(result), postId))
  }

  updateState(isThumbsUp) {
    const {
      $likeButtons,
      $dislikeButtons,
      $likeFeedback,
    } = this;

    const $pressedButtons = isThumbsUp ? $likeButtons : $dislikeButtons;
    const $otherButtons = isThumbsUp ? $dislikeButtons : $likeButtons;

    // set correct icons
    if ($pressedButtons.hasClass('active')) {
      $.each($pressedButtons, (_, button) => {
        $(button).removeClass('active')
      });
    } else {
      $.each($pressedButtons, (_, button) => {
        $(button).addClass('active')
      });
    }

    $.each($otherButtons, (_, button) => {
      $(button).removeClass('active');
    });

    // update feedback
    if ($likeButtons.hasClass('active')) {
      $likeFeedback.addClass('d-inline');
      $likeFeedback.removeClass('d-none')
    } else {
      $likeFeedback.removeClass('d-inline');
      $likeFeedback.addClass('d-none');
    }


  }

  updatePercentage({like_percentage}, postId) {
    if (like_percentage) {
      $(`.like-percentage[data-post-id="${postId}"]`)
        .text(like_percentage)
        .parent()
        .removeClass('d-none');
    } else {
      $(`.like-percentage[data-post-id="${postId}"]`)
        .parent()
        .addClass('d-none');
    }
  }

}



// WEBPACK FOOTER //
// ./scripts/modules/LikeController.js